<div class="col-md-12 clear-all top-nav flex-container ">
  <div class="col-md-6 h-100 nav-right pl-20  ">

    <span *ngIf='visibleBackNav' tabindex="0" id="top-nav-cta-left" name="top-nav-cta-left" (click)="goBack()"
      class="dls-button dls-prev-btn reflect " [ngClass]="{'disable-control':!enableBackNav}" (keyup.enter)="goBack()">
      <i class="icon icon-chevron-left"></i>
      <a class="nav-btn ml-15 mr-0 font-weight" [ngClass]="{'pointer':enableBackNav}" id="back-text" aria-label="back">
        {{router.url === '/apply/clear-to-apply' ? contentData.contentTopNavigationBar.backToYourQuotes :
        contentData.contentTopNavigationBar.back}}</a>
    </span>

  </div>
  <div class="col-md-6 text-right nav-right h-100 pr-22 " *ngIf="visibleSaveProgress">
    <!-- <div *ngIf="(button && button.enableQuote);then viewQuote else viewSave"></div> -->
    <a *ngIf="enableQuote && !abc" id="top-nav-cta-right" tabindex="0" name="top-nav-cta-right"
      class="nav-btn pointer reflect" (click)="retriveQuote()" (keyup.enter)="retriveQuote()">
      <u>{{contentData.contentTopNavigationBar.retrieveQuote}}</u>
    </a>
    <strong *ngIf="closeBtnEnabled" tabindex="0" id="top-nav-cta-right" name="top-nav-cta-right"
      class="nav-btn pointer reflect" (click)="close()"
      (keyup.enter)="close()">{{contentData.contentTopNavigationBar.close}}</strong>
    <!-- <span *ngIf="!enableQuote" class="saveContinue nav-btn pointer" (click)="saveProgress()">Save Progress & Exit</span> -->
    <span>
      <app-save #savecomp [emitInvalidEvtFlag]="emitInvalidEvtFlag" [cdRefParent]="cdRefParent"
        [parentFormToJustToClear]="parentFormToJustToClear" [parentElement]="parentElement"
        [parentFormToValidate]="parentFormToValidate" [saverAndReturnObj]="saverAndReturnObj" (closeSaveModal)="close()"
        [location]="'contentTop'"
        *ngIf="!enableQuote && !abc && !closeBtnEnabled
         && router.url !== '/home/get-your-online-quote' && router.url !== '/apply/your-product-application' && router.url !== '/home/update-my-details' && router.url !== '/home/guidance-and-advice'"></app-save>
    </span>
  </div>
</div>
<app-modal *ngIf="isLocked" [modalConfig]="lockedAlertModalConfig" (closeModal)="closeLockedModal()"
  (primaryBtnClick)="closeLockedModal()" [saveDataFlag]="false">
</app-modal>